module.exports = __webpack_public_path__ + "static/media/note-soul.2b037bab.png";